import { useMemo } from 'react';

import { useTranslation } from '@/i18n';

import { holidayService } from '@/api/domains/attendance';
import type { HolidayExportParams } from '@/api/domains/attendance/services/holiday.service';
import { useExport } from '@/hooks/ui/useExport';
import type { UseExportResult } from '@/hooks/ui/useExport';
import type { PaginatedListSort } from '@/hooks/ui/usePaginatedList';


export interface UseHolidayExportParams {
  searchText: string;
  sort: PaginatedListSort | undefined;
  year?: number | null;
  month?: number | null;
  holidayTypeId?: number | null;
}

export type UseHolidayExportResult = UseExportResult;

export function useHolidayExport({
  searchText,
  sort,
  year,
  month,
  holidayTypeId,
}: UseHolidayExportParams): UseHolidayExportResult {
  const { t: translate } = useTranslation();

  const exportParams = useMemo<HolidayExportParams>(
    () => ({
      searchText: searchText || undefined,
      sort,
      year: year ?? undefined,
      month: month ?? undefined,
      holidayTypeId: holidayTypeId ?? undefined,
    }),
    [searchText, sort, year, month, holidayTypeId],
  );

  return useExport({
    exportFn: () => holidayService.exportFile(exportParams),
    successMessage: translate('attendance:holiday.messages.exportSuccess'),
    errorMessage: translate('attendance:holiday.messages.exportError'),
  });
}
